module.exports = __webpack_public_path__ + "src/asset/svg/logo.svg?5e6c74038d8ebe3549b8e0b1fed82fd9";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/logo.svg
// module id = 89
// module chunks = 0